export function formatKickoff(iso) {
  const d = new Date(iso);
  return {
    date: d.toLocaleDateString("en-US", { weekday: "short", month: "short", day: "numeric" }),
    time: d.toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit" }) + " ET",
    day: d.toLocaleDateString("en-US", { weekday: "long" }),
  };
}
